import { IconButton, Typography, Stack, Tooltip } from '@mui/material';

export const SelectedItemsHeader = ({
  clearAll,
  title,
}: {
  clearAll: () => void;
  title: string;
}) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      className='w-full'
    >
      <Typography>{title}</Typography>
      <Tooltip title='Clear all'>
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            clearAll();
          }}
        >
          <i className='material-symbols-filter-alt-off-outline-rounded text-textPrimary h-[18px] w-[18px]'></i>
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
